import styled from 'styled-components';

import {
  Button,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

export const Play = styled(Button).attrs({
  icon: 'fas fa-play-circle',
  appearance: 'primary',
})`
  width: 100%;
  padding: 14px 12px;
  padding-right: 26px;
  font-size: 15px;
  align-items: center;
  position: relative;

  & > i {
    font-size: 20px;
  }
`;

export const Remove = styled.div`
  font-size: 12px;
  position: absolute;
  top: 17px;
  right: 14px;
`;

export const ModalContent = styled(Flex).attrs({
  column: true,
  justify: 'center',
  align: 'center',
  spacing: 8,
})`
  width: 65%;
  min-height: 600px;
  margin: auto;
`;

export const Video = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 9%;
  padding-bottom: 38%;
`;

export const Frame = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
